import Carousel from "../components/Carousel";
export default class RotatingGrid {
  constructor(section) {
    const rotatingGrid = section.el.querySelector('.grid-carousel');
    const carousel = new Carousel({
      root: rotatingGrid,
      class: 'grid-carousel-control',
      type: 'distance',
      distance: 260
    });
  }
}
